/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle, FaTimes, FaImage } from 'react-icons/fa';
import './ConfirmModal.css';

export default function FileSizeLimitModal() {
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    const handleEvent = (e) => {
      if (e && e.detail) {
        setModalData(e.detail);
      }
    };

    window.addEventListener('file-size-limit-exceeded', handleEvent);
    return () => {
      window.removeEventListener('file-size-limit-exceeded', handleEvent);
    };
  }, []);

  const handleClose = () => {
    setModalData(null);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && modalData) {
        handleClose();
      }
    };
    if (modalData) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [modalData]);

  if (!modalData) return null;

  const { fileName, sizeMB, limitMB = 5 } = modalData;

  return (
    <div className="premium-confirm-overlay" onClick={handleClose} style={{ zIndex: 999999 }}>
      <div
        className="premium-confirm-card"
        onClick={(e) => e.stopPropagation()}
        style={{
          border: '1px solid rgba(245, 158, 11, 0.45)',
          boxShadow: '0 25px 60px rgba(0, 0, 0, 0.85), 0 0 35px rgba(245, 158, 11, 0.22)',
          maxWidth: '460px'
        }}
      >
        <div
          className="confirm-top-glow"
          style={{
            background: 'linear-gradient(90deg, transparent, #f59e0b, transparent)',
            boxShadow: '0 0 15px rgba(245, 158, 11, 0.7)'
          }}
        />

        <button className="confirm-close-btn" onClick={handleClose} title="Close">
          <FaTimes size={13} />
        </button>

        <div className="confirm-icon-wrapper" style={{ marginBottom: '1.25rem' }}>
          <div
            className="confirm-icon-badge"
            style={{
              background: 'rgba(245, 158, 11, 0.12)',
              border: '1px solid rgba(245, 158, 11, 0.4)',
              color: '#f59e0b',
              boxShadow: '0 0 20px rgba(245, 158, 11, 0.25)',
              width: '56px',
              height: '56px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <FaExclamationTriangle size={24} />
          </div>
        </div>

        <h3 className="confirm-modal-title" style={{ color: '#fff', fontSize: '1.3rem', fontWeight: '600', marginBottom: '0.75rem' }}>
          File Size Limit Exceeded
        </h3>

        <div className="confirm-modal-desc" style={{ color: '#d1d5db', fontSize: '0.925rem', lineHeight: '1.6' }}>
          <p style={{ margin: '0 0 0.75rem 0' }}>
            Please upload an image smaller than <strong style={{ color: '#f59e0b' }}>{limitMB} MB</strong>.
          </p>

          {fileName && (
            <div
              style={{
                background: 'rgba(255, 255, 255, 0.04)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '8px',
                padding: '0.65rem 0.95rem',
                margin: '0.85rem 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                fontSize: '0.85rem',
                color: '#9ca3af'
              }}
            >
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '240px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  color: '#f3f4f6'
                }}
              >
                <FaImage size={14} style={{ color: '#f59e0b', flexShrink: 0 }} />
                {fileName}
              </span>
              {sizeMB && <span style={{ color: '#ef4444', fontWeight: '600', flexShrink: 0, paddingLeft: '8px' }}>{sizeMB} MB</span>}
            </div>
          )}

          <p style={{ margin: '0', fontSize: '0.825rem', color: '#9ca3af' }}>
            The maximum allowed file size is <strong>{limitMB} MB</strong>. Please compress or select a smaller image.
          </p>
        </div>

        <div style={{ marginTop: '1.75rem', display: 'flex', justifyContent: 'center' }}>
          <button
            type="button"
            onClick={handleClose}
            style={{
              background: 'linear-gradient(135deg, #c4a882 0%, #a68960 100%)',
              color: '#0c0b0a',
              border: 'none',
              padding: '0.65rem 2.25rem',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '0.875rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 4px 14px rgba(196, 168, 130, 0.35)'
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = 'translateY(-1px)')}
            onMouseOut={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
          >
            Understood
          </button>
        </div>
      </div>
    </div>
  );
}
